class CartCrossSell extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.addEventListener('click', this.onClick, { signal: this.controller.signal });
  }

  disconnectedCallback() { this.controller?.abort(); }

  onClick = (event) => {
    const arrow = event.target.closest('[data-direction]');
    if (!arrow) return;
    const track = this.querySelector('.cart-cross-sell__track');
    track.scrollBy({ left: Number(arrow.dataset.direction) * track.clientWidth * 0.8, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  };
}

if (!customElements.get('cart-cross-sell')) customElements.define('cart-cross-sell', CartCrossSell);
